import type { Observable } from 'rxjs';
import type { PublishedLanding } from '../domain/published-landing.model';

export abstract class PublishedLandingGateway {
  abstract getBySlug(slug: string, locale: string): Observable<PublishedLanding>;
}
